import LogRocket from 'logrocket';
import mobile from 'is-mobile';

// We're currently not interested in mobile users,
// and those sessions cost us more for little value
if (!mobile() && process.env.NODE_ENV === 'production') {
  LogRocket.init('dgy8s6/rsspipedreamcom');
}
